import { ListPageHeader } from '../shared/list-page/ListPageHeader';

import { GIFT_PASS_LIST_PATH } from './gift-passes-model';

const CRUMB = 'Customers › Gift passes';

export function GiftPassDetailHeader({ code }: { code?: string }) {
  return (
    <ListPageHeader
      crumb={code ? `${CRUMB} › ${code}` : CRUMB}
      title={code ? `Gift pass ${code}` : 'Gift pass'}
      backTo={GIFT_PASS_LIST_PATH}
      backLabel="Back to gift passes"
    />
  );
}
